export const decodeProtectedData = (base64Encoded: string): string => {
  try {
    // We use decodeURIComponent(escape(atob(str))) to safely handle UTF-8 characters
    // since standard atob() can break on multi-byte characters (like Arabic).
    return decodeURIComponent(escape(atob(base64Encoded)));
  } catch (error) {
    console.error('Error decoding protected data:', error);
    return '';
  }
};

export const PROTECTED_DATA = {
  // "info@mohammedtaha.site"
  email: 'aW5mb0Btb2hhbW1lZHRhaGEuc2l0ZQ==',
  // "mailto:info@mohammedtaha.site"
  emailHref: 'bWFpbHRvOmluZm9AbW9oYW1tZWR0YWhhLnNpdGU=',
  // "+213 (0) 562 77 80 33"
  phone: 'KzIxMyAoMCkgNTYyIDc3IDgwIDMz',
  // "tel:+213777637033"
  phoneHref: 'dGVsOisyMTM3Nzc2MzcwMzM=',
  // "Bir El-Djir, Oran, Algeria"
  addressEn: 'QmlyIEVsLURqaXIsIE9yYW4sIEFsZ2VyaWE=',
  // "بير الجير، وهران، الجزائر"
  addressAr: '2KjZitixINin2YTYrNmK2LHYjCDZiNmH2LHYp9mG2Iwg2KfZhNis2LLYp9im2LE='
};
